import domReady from '@wordpress/dom-ready';

domReady(() => {
  let lastScrollTop = 0;
  const stickyThreshold = 40;
  const navbar = document.querySelector('.navbar');
  const topNavbar = document.querySelector('.top-navbar');
  const body = document.body;
  let scrollDirection = 'up';

  function updateVisibility(element, visible) {
    if (!element) return;
    element.style.visibility = visible ? 'visible' : 'hidden';
    element.classList.toggle('hidden', !visible);
  }

  function updateBodyClass(direction) {
    body.classList.remove('scroll-up', 'scroll-down');
    body.classList.add(`scroll-${direction}`);
  }

  function handleScroll() {
    const currentScroll = window.scrollY;

    if (currentScroll > lastScrollTop) {
      scrollDirection = 'down';
    } else if (currentScroll < lastScrollTop) {
      scrollDirection = 'up';
    }

    updateBodyClass(scrollDirection);

    const shouldShow =
      scrollDirection === 'up' || currentScroll <= stickyThreshold;

    updateVisibility(navbar, shouldShow);
    updateVisibility(topNavbar, shouldShow);

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }

  window.addEventListener('scroll', () => {
    window.setTimeout(handleScroll, 50);
  });

  handleScroll();

  document
    .getElementById('back-to-top')
    .addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
});
